
import {AllSongList} from '../pages';


export default function Home(){
    return(
        
            
        <center>
            <AllSongList/>
        </center>
              
     
    );
}